import { render, staticRenderFns } from "./SwipeItem.vue?vue&type=template&id=8df0f3d4&scoped=true"
import script from "./SwipeItem.vue?vue&type=script&lang=js"
export * from "./SwipeItem.vue?vue&type=script&lang=js"
import style0 from "./SwipeItem.vue?vue&type=style&index=0&id=8df0f3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df0f3d4",
  null
  
)

export default component.exports